
const m = window.require("@ember/test/adapter");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
